<template>
    <div>
        <loading :active.sync="loading.app" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="pageTitle">Kemitraan</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" class="mb-3"  v-if="loading.app == false">
            <div class="section curved-header pt-1" style="--height-curved:100px;">
                <div class="wallet-card">
                    <div class="balance">
                        <div class="col-6 text-left">
                            <span class="title">Kode Referral</span>
                            <h1 class="total"><span>{{ customer.affiliate_id }}</span></h1>
                        </div>
                        <div class="col-6 text-left">
                            <span class="title">Komisi</span>
                            <h1 class="total" v-if="customer.role == 'Member'"><span>Rp {{  setting.komisi_transaction_referral_basic | rupiah }} <small>/ Transaksi</small></span></h1>
                            <h1 class="total" v-else-if="customer.role == 'Premium' || customer.role == 'Bisnis'"><span>Rp {{  setting.komisi_transaction_referral_premium | rupiah }} <small>/ Transaksi</small></span></h1>
                            <h1 class="total" v-else-if="customer.role == 'H2H'"><span>Rp 0<small>/ Transaksi</small></span></h1>
                            <h1 class="total" v-else-if="customer.role == 'MD'"><span><small>Selisih Harga Jual</small></span></h1>
                        </div>
                    </div>
                    <div class="wallet-footer">
                        <router-link :to="{name:'referral.index'}" class="btn btn-primary btn-block">
                            Lihat Selengkapnya <ion-icon name="chevron-forward-sharp"></ion-icon>
                        </router-link>
                    </div>
                </div>
                <!-- <div class="detail-card text-center" v-if="customer.role == 'Member'">
                    <img :src="require('@/assets/member.png')" alt="image" class="image mb-2 mt-1" style="height:100px;">
                    <h3>Qios Member</h3>
                    <p>Status kemitraan yang didapat saat pertama kali mendaftar dan mempunyai batasan akses pada beberapa fitur.</p>
                </div> 
                <div class="detail-card text-center" v-else-if="customer.role == 'Premium'">
                    <img :src="require('@/assets/premium.png')" alt="image" class="image mb-2 mt-1" style="height:100px;">
                    <h3>Qios Premium</h3>
                    <p>Status kemitraan yang mendapatkan berbagai keuntungan dengan berbagai bonus melimpah.</p>
                </div>
                <div class="detail-card text-center" v-else-if="customer.role == 'Bisnis'">
                    <img :src="require('@/assets/bisnis.png')" alt="image" class="image mb-2 mt-1" style="height:100px;">
                    <h3>Qios Bisnis</h3>
                    <p>Status kemitraan bagi mitra yang memiliki toko/outlet fisik seperti toko sembako, konter pulsa, loket ppob, dll.</p>
                </div>
                <div class="detail-card text-center" v-else-if="customer.role == 'H2H'">
                    <img :src="require('@/assets/h2h.png')" alt="image" class="image mb-2 mt-1" style="height:100px;">
                    <h3>Qios H2H</h3>
                    <p>Status kemitraan yang dikhususkan untuk kerjasama B2B dalam penyediaan produk digital.</p>
                </div>
                <div class="detail-card text-center" v-else-if="customer.role == 'MD'">
                    <img :src="require('@/assets/MD.png')" alt="image" class="image mb-2 mt-1" style="height:100px;">
                    <h3>Master Dealer</h3>
                    <p>Status kemitraan bagi mitra yang menjalin kerjasama kontrak dengan pihak QIOSFIN dalam promosi dan pemasaran layanan QIOSFIN.</p>
                </div> -->
            </div>
            <!-- <div class="section detail-transaction-section" style="margin-top:20px;">
                <div class="wallet-card">
                    <div class="balance">
                        <div class="col-6 text-left">
                            <span class="title">Kode Referral</span>
                            <h1 class="total"><span>{{ customer.affiliate_id }}</span></h1>
                        </div>
                        <div class="col-6 text-left">
                            <span class="title">Bonus Komisi</span>
                            <h1 class="total"><span>Rp {{ customer.komisi | rupiah }}</span></h1>
                        </div>
                    </div>
                    <div class="wallet-footer">
                        <router-link :to="{name:'referral.index'}" class="btn btn-primary btn-block">
                            Lihat Selengkapnya <ion-icon name="chevron-forward-sharp"></ion-icon>
                        </router-link>
                    </div>
                </div>
            </div> -->
            <!-- <div class="section mt-2" v-if="customer.role == 'Member'">
                <router-link :to="{name: 'account.upgrade'}" class="btn btn-outline-primary btn-block btn-lg">
                    YUK UPGRADE PREMIUM SEKARANG
                </router-link>
            </div> -->
            <!-- <div class="section full mt-4">
                <div class="listview-title pl-3 pr-3" style="font-weight:bold;">Status Verifikasi Akun</div>
                <ul class="listview image-listview inset">
                    <li>
                        <router-link :to="{name:'account.email'}" class="item">
                            <img :src="customer.email_verified == null ? require('@/assets/unverified.png'):require('@/assets/verified.png')" alt="image" class="image">
                            <div class="in">
                                <div><b class="mr-1">Alamat Email</b></div>
                                <span class="text-primary text-right">Klik disini</span>
                            </div>
                        </router-link>
                    </li>
                    <li>
                        <a href="Javascript:;" @click.prevent="onClickVeryButton" class="item">
                            <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="customer.account_verified_status != 'APPROVED' ? require('@/assets/unverified.png'):require('@/assets/verified.png')" alt="image" class="image">
                            <div class="in">
                                <div><b class="mr-1">Data Diri</b></div>
                                <span class="text-primary text-right">Klik disini</span>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="Javascript:;" @click.prevent="onClickVeryButton" class="item">
                            <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="customer.account_verified_status != 'APPROVED' ? require('@/assets/unverified.png'):require('@/assets/verified.png')" alt="image" class="image">
                            <div class="in">
                                <div><b class="mr-1">Data Toko/Outlet</b></div>
                                <span class="text-primary text-right">Klik disini</span>
                            </div>
                        </a>
                    </li>
                </ul>
            </div> -->
            <!-- <div class="section full mt-1">
                <ul class="listview simple-listview inset">
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b v-if="customer.account_verified_status == false || customer.account_verified_status == 'REJECTED'">Rp {{VUE_ENV.VUE_APP_LIMIT_SALDO | rupiah}}</b>
                                <b v-else>Tidak Ada</b>
                                <footer>Limit Saldo</footer>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b v-if="customer.account_verified_status == false || customer.account_verified_status == 'REJECTED'">Rp {{VUE_ENV.VUE_APP_MAX_TOPUP | rupiah}}</b>
                                <b v-else>Tidak Ada</b>
                                <footer>Maksimal Deposit</footer>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b v-if="customer.account_verified_status == false || customer.account_verified_status == 'REJECTED'">Rp {{VUE_ENV.VUE_APP_MAX_TRX | rupiah}}</b>
                                <b v-else>Tidak Ada</b>
                                <footer>Maksimal Nominal Transkasi</footer>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b v-if="customer.account_verified_status == false || customer.account_verified_status == 'REJECTED'">Rp {{VUE_ENV.VUE_APP_LIMIT_TRX | rupiah}}</b>
                                <b v-else>Tidak Ada</b>
                                <footer>Maksimal Akumulasi Transkasi</footer>
                            </div>
                        </div>
                    </li>
                </ul>
            </div> -->
            
            <div class="section inset" style="margin-top:50px;">
                <div class="order-menu p-0 m-0">
                    <h4 style="font-weight:bold;" class="mb-0">Keuangan</h4>
                    <span style="font-size:12px;">Fitur Layanan Keuangan</span>
                    <hr style="margin-top:5px;">
                    <div class="menu">
                        <div class="item" style="flex:none;">
                            <router-link :to="{name:'transfer'}">
                                <img :src="require('@/assets/icon_menu/transfer_saldo.png')" alt="image" class="imaged" style="width:60%;">
                                <strong style="margin:3px;font-size:10px;"><span>Transfer Saldo</span></strong>
                            </router-link>
                        </div>
                        <div class="item" style="flex:none;">
                            <a href="Javascript:;" @click="coming">
                                <img :src="require('@/assets/icon_menu/kirim_uang.png')" alt="image" class="imaged" style="width:60%;">
                                <strong style="margin:3px;font-size:10px;"><span>Kirim Uang</span></strong>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section inset mt-2">
                <div class="order-menu p-0 m-0">
                    <h4 style="font-weight:bold;" class="mb-0">Menu Referral</h4>
                    <span style="font-size:12px;">Kelola Downline dan Komisi Referral</span>
                    <hr style="margin-top:5px;">
                    <div class="menu">
                        <div class="item" style="flex:none;">
                            <router-link :to="{name:'referral.downline'}">
                                <img :src="require('@/assets/icon_menu/list_downline.png')" alt="image" class="imaged" style="width:60%;">
                                <strong style="margin:3px;font-size:10px;"><span>List Downline</span></strong>
                            </router-link>
                        </div>
                        <div class="item" style="flex:none;">
                            <router-link :to="{name:'referral.komisi'}">
                                <img :src="require('@/assets/icon_menu/list_komisi.png')" alt="image" class="imaged" style="width:60%;">
                                <strong style="margin:3px;font-size:10px;"><span>List Komisi</span></strong>
                            </router-link>
                        </div>
                        <div class="item" style="flex:none;">
                            <router-link :to="{name:'withdrawal'}">
                                <img :src="require('@/assets/icon_menu/tarik_komisi.png')" alt="image" class="imaged" style="width:60%;">
                                <strong style="margin:3px;font-size:10px;"><span>Tukar Komisi</span></strong>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section inset mt-2">
                <div class="order-menu p-0 m-0">
                    <h4 style="font-weight:bold;" class="mb-0">Peralatan</h4>
                    <span style="font-size:12px;">Layanan atau Fitur untuk membantu usahamu</span>
                    <hr style="margin-top:5px;">
                    <div class="menu">
                        <div class="item" style="flex:none;">
                            <a href="Javascript:;" @click="coming">
                                <img :src="require('@/assets/icon_menu/list_harga.png')" alt="image" class="imaged" style="width:60%;">
                                <strong style="margin:3px;font-size:10px;"><span>Daftar Harga</span></strong>
                            </a>
                        </div>
                        <div class="item" style="flex:none;">
                            <a href="Javascript:;" @click="coming">
                                <img :src="require('@/assets/icon_menu/download_banner.png')" alt="image" class="imaged" style="width:60%;">
                                <strong style="margin:3px;font-size:10px;"><span>Download Banner</span></strong>
                            </a>
                        </div>
                        <div class="item" style="flex:none;">
                            <a href="Javascript:;" @click="coming">
                                <img :src="require('@/assets/icon_menu/topup_poin.png')" alt="image" class="imaged" style="width:60%;">
                                <strong style="margin:3px;font-size:10px;"><span>Topup Poin</span></strong>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import $axios from './../api.js'
export default {
    name: 'account.upgrade',
    data() {
        return {
            loading:{
                dialog: false,
                app: true
            }
        }
    },
    created() {
        this.loading.app = false
        if(Object.keys(this.setting).length == 0){
            this.loading.app = true
            this.getSetting().then(() => {
                this.loading.app = false
            }).catch(() => {
                this.loading.app = false
            })
        }
    },
    computed: {
        ...mapState(['customer','setting','toast','VUE_ENV'])
    },
    methods: {
        ...mapActions(['getSetting','getCustomer','coming']),
        showDialog(value){
            let element = this.$refs.dialog.$el
            window.$(element).modal(value)
        },
        submit(){
            this.loading.dialog = true
            this.$store.commit('SET_TOAST', {show:false})
            $axios.post('/upgrade').then((response) => {
                this.showDialog('hide')
                this.loading.dialog = false
                this.$store.commit('SET_CUSTOMER', response.data.data)
                this.$router.push({name:'account'})
            }).catch((error) => {
                this.showDialog('hide')
                this.loading.dialog = false
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default'})
                setTimeout(() => this.$store.commit('SET_TOAST', {show:false}) , 5000);
            })
        },
        onClickVeryButton() {
            this.loading.app = true
            this.getCustomer().then((response) => {
                this.loading.app = false
                if(response.data.account_verified_status == false || response.data.account_verified_status == "REJECTED"){
                    if (typeof window.AndroidNative !== 'undefined') {
                        window.AndroidNative.showFormVerification();
                    } else {
                        this.$store.commit('SET_TOAST', {show:true,message:'Fitur ini hanya bisa digunakan melalui aplikasi',tipe:'default',icon:'warning'})
                    }
                }else if(response.data.account_verified_status == "PROCESS"){
                    this.$store.commit('SET_TOAST', {show:true,message:'Masih dalam proses verifikasi data, proses ini memberlukan waktu maksimal 1x24 jam (tidak termasuk hari sabtu, minggu dan hari libur nasional)',tipe:'default',icon:'warning'})
                }else if(response.data.account_verified_status == "APPROVED"){
                    this.$store.commit('SET_TOAST', {show:true,message:'Data diri telah berhasil terverifikasi',tipe:'default',icon:'success'})
                }
            })
           
        }
    },
    destroyed() {
        this.$store.commit('RESET_TOAST')
    },
}
</script>